import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path
      key='0'
      d='M21.6,5c0-0.4-0.3-0.7-0.7-0.7h-5l0-0.8c0-0.6,0-0.8-0.1-1.1c-0.2-0.6-0.7-1-1.2-1.3C14.2,1,14.1,1,12.1,1
	C10.6,1,10,1,9.8,1.1c-0.4,0.1-0.7,0.3-1,0.5c-0.5,0.5-0.7,1-0.7,2v0.7h-5C2.7,4.2,2.4,4.6,2.4,5v0c0,0.4,0.3,0.7,0.7,0.7
	c0.5,0,1,0,1,0c0,0,0.2,3.4,0.5,7.3C4.8,17.4,5,20.1,5,20.4c0.2,1.2,1.1,2.2,2.3,2.5C7.6,23,7.9,23,12,23c4.9,0,4.6,0,5.4-0.4
	c0.9-0.5,1.5-1.4,1.6-2.4c0-0.2,0.2-3.5,0.5-7.3s0.4-7.2,0.4-7.2h1C21.3,5.7,21.6,5.4,21.6,5L21.6,5z M9.7,4.2V3.6V2.9
	c0-0.2,0.1-0.3,0.3-0.3h4.1c0.2,0,0.3,0.1,0.3,0.3v1.3h0l0,0H12H9.7L9.7,4.2z M18.3,6c0,0.1-0.2,3.2-0.4,7c-0.3,4.7-0.4,7-0.5,7.2
	c-0.1,0.5-0.6,1-1,1.1c-0.2,0.1-1.2,0.1-4.5,0.1H7.7l-0.3-0.1C7.3,21.2,7.1,21.1,7,21c-0.2-0.2-0.5-0.7-0.5-0.9
	c0-0.2-0.8-13.7-0.8-14V5.7H12h6.3V6z'
    />,
    <path key='1' d='M12,18.6c-0.4,0-0.8-0.3-0.8-0.8V9.2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v8.6C12.8,18.2,12.4,18.6,12,18.6z' />,
    <path key='2' d='M15.1,18.6c-0.4,0-0.8-0.3-0.8-0.8V9.2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v8.6C15.8,18.2,15.5,18.6,15.1,18.6z' />,
    <path key='3' d='M8.9,18.6c-0.4,0-0.8-0.3-0.8-0.8V9.2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v8.6C9.7,18.2,9.3,18.6,8.9,18.6z' />,
  ],
  'CircleGeofence'
);

const DeleteIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(DeleteIcon);
